export const deviceSize = {
  mobile: 576,
  tablet: 768,
  laptop: 992,
  desktop: 1200,
};
